import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import Menubar from '../../Shared/MenuBar/Menubar';
import { FaFacebookF, FaLinkedinIn } from 'react-icons/fa';
import { FiGithub } from 'react-icons/fi';
import { AiOutlineMedium } from 'react-icons/ai';
import './Header.css'
import { Link } from 'react-router-dom';
import Particles from 'react-particles-js';

const Header = () => {
    return (
        <div className="header-section">
            <Menubar />
            <Container className='header-container'>
                {/* Header menu section */}

                {/* Header details section */}
                <Row>
                    <Col md={5} align="center" className="p-2 d-md-flex align-items-center">
                        <img className="aboutMeImage  m-sm-5 d-sm-flex align-items-center headerImage" src={"https://i.ibb.co/zrMY71g/IMG-20200211-192039-removebg-2-5.png"} alt="" />
                    </Col>
                    <Col className='d-flex align-items-center header-discription ' md={7}>
                        <div>
                            <h1 className="header-hello"> Hello I'm</h1>
                            <h1 className="header-name">Moshiuzzaman</h1>
                            <h3 className="header-position">MERN || Junior Web Developer</h3>
                            <p className="header-summary">I enjoy creating modern web applications. I have Deep knowledge and work with HTML 5, CSS 3, Bootstrap, JSX, JavaScript, ES6, React js. I also have Knowledge and proficiency with react-bootstrap, Material-UI, Redux, and server-side node.js, express.js, MongoDB. </p>
                            <div className="headers-icon">
                                <a target='_blank' href='https://www.linkedin.com/in/md-moshiuzzaman-8699641b7/'><FaLinkedinIn className='headers-single-icon' /></a>
                                <a target='_blank' href="https://github.com/moshiuzzaman"><FiGithub className='headers-single-icon' /></a>
                                <a target='_blank' href="https://web.facebook.com/freelancershozon"><FaFacebookF className='headers-single-icon' /></a>
                                <a target='_blank' href="https://shozonraj.medium.com/"><AiOutlineMedium className='headers-single-icon' /></a>
                            </div>
                            <div className='mt-4'>
                                <Button target="_blank" className='buttonstyle' href="https://drive.google.com/file/d/1_g6Ab0KTMDQuT4hTUJ5IfZiaQLmzEEaB/view?usp=sharing">My Resume</Button>
                                <Link to="contactme"><Button className='buttonstyle'>Contact Me</Button></Link>
                            </div>
                        </div>
                    </Col>
                </Row>

            </Container>
            <Particles
                params={{
                    "particles": {
                        "number": {
                            "value": 20,
                            "density": {
                                "enable": true,
                                "value_area": 1803.4120608655228
                            }
                        },
                        "color": {
                            "value": "#fff"
                        },
                        "shape": {
                            "type": "circle",
                            "stroke": {
                                "width": 2,
                                "color": "#fff"
                            },
                            "polygon": {
                                "nb_sides": 4
                            },
                            "image": {
                                "src": "img/github.svg",
                                "width": 100,
                                "height": 50
                            }
                        },
                        "opacity": {
                            "value": .8,
                            "random": false,
                            "anim": {
                                "enable": true,
                                "speed": 5,
                                "opacity_min": 1,
                                "sync": false
                            }
                        },
                        "size": {
                            "value": 3,
                            "random": true,
                            "anim": {
                                "enable": true,
                                "speed": 10,
                                "size_min": 0.1,
                                "sync": false
                            }
                        },
                        "line_linked": {
                            "enable": true,
                            "distance": 100,
                            "color": "#64ffda",
                            "opacity": .75,
                            "width": .50
                        },
                        "move": {
                            "enable": true,
                            "speed": 5,
                            "direction": "none",
                            "random": false,
                            "straight": false,
                            "out_mode": "out",
                            "bounce": true,
                            "attract": {
                                "enable": false,
                                "rotateX": 1000,
                                "rotateY": 1200
                            }
                        }
                    },
                    "interactivity": {
                        "detect_on": "window",
                        "events": {
                            "onhover": {
                                "enable": true,
                                "mode": "repulse"
                            },
                            "resize": true
                        },
                        "modes": {
                            "grab": {
                                "distance": 100,
                                "line_linked": {
                                    "opacity": 1
                                }
                            },
                            "bubble": {
                                "distance": 400,
                                "size": 40,
                                "duration": 2,
                                "opacity": 8,
                                "speed": 3
                            },
                            "repulse": {
                                "distance": 100,
                                "duration": 0.4
                            },
                            "push": {
                                "particles_nb": 4
                            },
                            "remove": {
                                "particles_nb": 2
                            }
                        }
                    },
                    "retina_detect": true
                }} />
            {/* <Particles
                params={{
                    "particles": {
                        "number": {
                            "value": 150
                        },
                        "size": {
                            "value": 3
                        }
                    },
                    "interactivity": {
                        "events": {
                            "onhover": {
                                "enable": true,
                                "mode": "repulse"
                            }
                        }
                    }
                }} /> */}
        </div>
    );
};

export default Header;